import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../lib/cn.js';
/*
 * `success` endi O'Z rangini oladi.
 *
 * Ilgari u `accent` tintida chizilardi va bu ishlardi — chunki urg'u rangining
 * o'zi yashil edi. SQB palitrasida urg'u KO'K bo'ldi, ya'ni eski bog'lanish
 * "zaxirada bor" ni ko'k qilib qo'yardi. Omborda esa yashil/sariq/qizil
 * uchligi ma'lumotning o'zi: xodim jadvalga qarab, o'qimasdan turib holatni
 * biladi va bu tusni brendga ergashtirib bo'lmaydi.
 */
const toneClass = {
    neutral: 'bg-surface-2 text-text-muted border-border',
    accent: 'bg-accent text-accent-contrast border-accent',
    success: 'bg-success-soft text-success border-success/25',
    warn: 'bg-warn-soft text-warn border-warn/25',
    danger: 'bg-danger-soft text-danger border-danger/25',
    info: 'bg-info-soft text-info border-info/25',
};
/** Holat yorlig'i — qatorda ham, sarlavhada ham bir xil balandlikda turadi. */
export const Badge = ({ tone = 'neutral', mono = false, className, ...rest }) => (_jsx("span", { className: cn('inline-flex items-center gap-1 rounded-[var(--radius-pill)] border', 'px-2 py-0.5 text-xs font-medium whitespace-nowrap', toneClass[tone], mono ? 'tabular' : undefined, className), ...rest }));
//# sourceMappingURL=Badge.js.map